import React from 'react';

export type State = {
  development: boolean;
  userId: string;
  userName: string;
  userTel: string;
  emailAddress: string;
  customerId: string;
  customerName: string;
  saasBillingAddressId: string;
  paymentGatewayId: string;
};

export type Action =
  | { type: 'SET_DEVELOPMENT'; development: boolean }
  | { type: 'SET_USER_ID'; userId: string }
  | { type: 'SET_USER_NAME'; userName: string }
  | { type: 'SET_EMAIL_ADDRESS'; emailAddress: string }
  | { type: 'SET_USER_TEL'; userTel: string }
  | { type: 'SET_CUSTOMER_ID'; customerId: string }
  | { type: 'SET_CUSTOMER_NAME'; customerName: string }
  | { type: 'SET_SAAS_BILLING_ADDRESS_ID'; saasBillingAddressId: string }
  | { type: 'SET_PAYMENT_GATEWAY_ID'; paymentGatewayId: string };

export const GlobalsContext = React.createContext(
  {} as {
    state: State;
    dispatch: React.Dispatch<Action>;
  },
);

export const reducer = (state: State, action: Action): State => {
  switch (action.type) {
    case 'SET_DEVELOPMENT':
      return {
        ...state,
        development: action.development,
      };
    case 'SET_USER_ID':
      return {
        ...state,
        userId: action.userId,
      };
    case 'SET_USER_NAME':
      return {
        ...state,
        userName: action.userName,
      };
    case 'SET_USER_TEL':
      return {
        ...state,
        userTel: action.userTel,
      };
    case 'SET_EMAIL_ADDRESS':
      return {
        ...state,
        emailAddress: action.emailAddress,
      };
    case 'SET_CUSTOMER_ID':
      return {
        ...state,
        customerId: action.customerId,
      };
    case 'SET_CUSTOMER_NAME':
      return {
        ...state,
        customerName: action.customerName,
      };
    case 'SET_SAAS_BILLING_ADDRESS_ID':
      return {
        ...state,
        saasBillingAddressId: action.saasBillingAddressId,
      };
    case 'SET_PAYMENT_GATEWAY_ID':
      return {
        ...state,
        paymentGatewayId: action.paymentGatewayId,
      };
    default:
      return state;
  }
};

export const initialState: State = {
  development: false,
  userId: '',
  userName: '',
  userTel: '',
  emailAddress: '',
  customerId: '',
  customerName: '',
  saasBillingAddressId: '',
  paymentGatewayId: '',
};

export const getCookie = (key: string) => {
  if (document.cookie !== '') {
    const cookies: { [key: string]: string } = {};
    const cookieLines = document.cookie.split('; ');
    for (let i = 0; i < cookieLines.length; i++) {
      const cookieLine = cookieLines[i].split('=');
      cookies[cookieLine[0]] = decodeURIComponent(cookieLine[1]);
    }
    return cookies[key];
  }
};

export const TIMEOUT_MSEC = 30 * 1000;

export const timeout = <T extends any>(
  promise: Promise<T>,
  milliseconds: number = TIMEOUT_MSEC,
): Promise<T> => {
  let timer: number;
  return Promise.race([
    promise,
    new Promise<T>((_resolve, reject) => {
      timer = window.setTimeout(reject, milliseconds);
    }),
  ]).finally(() => window.clearTimeout(timer));
};
